/*
 * Created on Tue Jul 30 2019
 * Author: Val Liu
 * Copyright (c) 2019
 */

export function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}